var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"outlined":"","items":_vm.availableUnits,"label":_vm.$t('configurations.report_unit')},model:{value:(_vm.unit),callback:function ($$v) {_vm.unit=$$v},expression:"unit"}})}
var staticRenderFns = []

export { render, staticRenderFns }